import {
  BrandApi,
  CategoryApi,
  Configuration,
  DeliveryApi,
  DiscountApi,
  ElasticApi,
  OrderApi,
  ParserApi,
  PaymentApi,
  ProductApi,
  StatsApi,
  VariantApi,
  AuthApi,
  BonusesApi,
  VerificationApi,
  ReferralsApi,
  CartApi,
  SeriesApi,
  FirebaseApi, WishlistApi,
} from '@generated-client/backend';

export * from '@generated-client/backend/models';

const config = new Configuration({
  basePath: '/api',
});

const ssrConfig = new Configuration({
  basePath: 'https://www.trwl.store/api',
});

export const BACKEND_API = {
  ElasticApi: new ElasticApi(config),
  ParserApi: new ParserApi(config),
  BrandApi: new BrandApi(config),
  SeriesApi: new SeriesApi(config),
  CategoryApi: new CategoryApi(config),
  ProductApi: new ProductApi(config),
  PaymentApi: new PaymentApi(config),
  OrderApi: new OrderApi(config),
  CartApi: new CartApi(config),
  DeliveryApi: new DeliveryApi(config),
  DiscountApi: new DiscountApi(config),
  StatsApi: new StatsApi(config),
  VariantApi: new VariantApi(config),
  AuthApi: new AuthApi(config),
  BonusesApi: new BonusesApi(config),
  ReferralsApi: new ReferralsApi(config),
  VerificationApi: new VerificationApi(config),
  FirebaseApi: new FirebaseApi(config),
  WishlistApi: new WishlistApi(config),
};

export const SSR_BACKEND_API = {
  ParserApi: new ParserApi(ssrConfig),
  ProductApi: new ProductApi(ssrConfig),
  BrandApi: new BrandApi(ssrConfig),
  ElasticApi: new ElasticApi(ssrConfig),
};
